import extendedFieldHooks from "ExtendedFields/selectorHooks";

import NavInline from "./NavInline";
import NavWithModal from "./NavWithModal";

const ExtendedFieldNav = () => {
  const [editWithModal] = extendedFieldHooks.useEditWithModal();
  if (editWithModal) return <NavWithModal />;
  return <NavInline />;
};

export default ExtendedFieldNav;
